
import { Route, Routes } from 'react-router-dom'
import { List } from './components'

export const ModuleRoutes = () => (
  <Routes>
    <Route path="" element={<List />} />
  </Routes>
)

export default ModuleRoutes
